<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>商户列表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="page-actions">
        <create @refresh="getList"></create>
        <addCoin></addCoin>
      </div>
      <merchant-list @refresh="getList"></merchant-list>
    </el-card>
  </div>
</template>

<script>
import './store';
import { mapActions, mapState, mapGetters, mapMutations } from 'vuex';
import MerchantList from './components/list';
import moment from 'moment';
import Create from './components/create';
import addCoin from './components/addCoin';

export default {
  name: 'Merchant',
  data() {
    return {};
  },
  components: {
    MerchantList,
    Create,
    addCoin
  },
  computed: {
    ...mapState('merchant', ['pagination'])
  },
  methods: {
    ...mapActions('merchant', [
      'listMerchants',
      'createMerchant',
      'getCoinList'
    ]),
    ...mapActions('recharge', ['listAllCoin']),
    getList(data = {}) {
      this.listMerchants({
        ...this.pagination,
        ...data
      });
    }
  },
  created() {
    this.getList();
    this.listAllCoin();
    this.getCoinList();
  }
};
</script>
